const config = {
    mode: "production", // Modes possibles : "maintenance" ou "production"
  };
  
  export default config;
  